var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"f4f4f8"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }